

import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import FileSaver from 'file-saver';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormModal, Button, Input, Text } from '../../../ui-kit';
import { SMALL_SIZE } from '../../Addons/components/Expandable/constants';
import { COPY_COOLDOWN } from '../constants/linkParams';
import { getUrlQRCode } from '../../ShareVideoLink/utils/qrCodeCanvas';
import ShareVideoLinkButton from '../../ShareVideoLink/components/ShareVideoLinkButton';
import LinkSettings from './LinkSettings';


import '../styles/_public-upload-modal.scss';
























const DOWNLOAD_QR_CODE_IMAGE_NAME = 'qr-code.png';
const TITLE = 'Team Uploader';
const SUBTITLE = 'Share the Team Uploader link to invite others to securely contribute media to this project';

const PublicUploadModal = (props) => {
  const {
    visible,
    size: { width },
    video,
    className,
    children,
    onClose,
    onSave,
    createVideoPublicLink,
    getVideoPublicLink,
    updateVideoPublicLink
  } = props;

  const [isCopied, setIsCopied] = useState(false);
  const [isExpirationSet, setIsExpirationSet] = useState(false);
  const [isPasswordSet, setIsPasswordSet] = useState(false);
  const [videoPublicLink, setVideoPublicLink] = useState(undefined);
  const [expiryDate, setExpiryDate] = useState(null);
  const [savedPassword, setSavedPassword] = useState(undefined);

  const { videoId } = video || {};

  const setDefaultValues = ({
    videoPublicLink: linkValue,
    expiryDate: expiryValue,
    password
  }) => {
    if (linkValue) {
      setVideoPublicLink(linkValue);
    }

    if (expiryValue) {
      setExpiryDate(expiryValue);
      setIsExpirationSet(true);
    }

    if (password) {
      setIsPasswordSet(true);
    }
  };

  const fetchPublicLink = async () => {
    if (videoPublicLink || !visible || !videoId) return;

    let { data } = await getVideoPublicLink(videoId);
    let linkData = (data || {}).getVideoPublicLink;

    if (!linkData) {
      await createVideoPublicLink({ videoId, input: { expiryDate } });
      // createVideoPublicLink may return null data, so refetch
      ({ data } = await getVideoPublicLink(videoId));
      linkData = (data || {}).getVideoPublicLink;
    }

    if (linkData) {
      const { link, expiryDate: videoLinkExpiryDate, password } = linkData;
      setDefaultValues({
        videoPublicLink: link,
        expiryDate: videoLinkExpiryDate,
        password
      });
    }
  };

  useEffect(() => {
    fetchPublicLink();
  }, [visible, videoId]);

  const handleCopySuccess = () => {
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, COPY_COOLDOWN);
  };

  const handleDownloadQRCode = async (link) => {
    const dataUrlWithQRCode = await getUrlQRCode(link);

    FileSaver.saveAs(dataUrlWithQRCode, DOWNLOAD_QR_CODE_IMAGE_NAME);
  };

  const toggleExpiration = (option) => {
    const { value } = option;
    if (value === 'project-completion') {
      setIsExpirationSet(false);
      setExpiryDate(null);
    } else {
      setIsExpirationSet(true);
    }
  };

  const togglePassword = () => {
    const newIsPasswordValue = !isPasswordSet;
    const newPasswordValue = '';

    setIsPasswordSet(newIsPasswordValue);
    setSavedPassword(newPasswordValue);
  };

  const handleSettingsChange = (settings) => {
    if (settings.savedPassword !== undefined) {
      setSavedPassword(settings.savedPassword);
    }
  };

  const handleClose = () => {
    setVideoPublicLink(undefined);
    onClose();
  };

  const handleSave = () => {
    handleCopySuccess();

    if (videoId) {
      updateVideoPublicLink({
        videoId,
        input: {
          expiryDate,
          password: savedPassword
        }
      });
    }

    if (onSave) {onSave();}
  };

  const link = videoPublicLink || '';
  const isMobile = width <= SMALL_SIZE;

  return (
    <div className={cx('public-upload-modal', className)}>
      <FormModal
        visible={visible}
        onClose={handleClose}
        title={TITLE}
        subtitle={SUBTITLE}
        hideFooter>

        <div className="public-upload-modal__link">
          <Input
            disabled
            defaultValue={link}
            key={link}
            className="public-upload-modal__link__url" />


          <CopyToClipboard text={link} onCopy={handleCopySuccess}>
            <ShareVideoLinkButton
              prefix={isCopied ? 'success' : 'duplicate'}
              disabled={isCopied || !link}
              isMobile={isMobile}
              className="public-upload-modal__link__copy"
              tooltipId="copy-link-btn"
              tooltipLabel="Copy link" />

          </CopyToClipboard>
        </div>
        <>
          <Text heading5>Share settings</Text>

          <LinkSettings
            isMobile={isMobile}
            isExpirationSet={isExpirationSet}
            isPasswordSet={isPasswordSet}
            savedPassword={savedPassword}
            expiryDate={expiryDate || ''}
            toggleExpiration={toggleExpiration}
            togglePassword={togglePassword}
            onSettingsChange={handleSettingsChange} />

        </>

        {children}

        <div className="public-upload-modal__controls">
          <ShareVideoLinkButton
            isMobile={isMobile}
            prefix="qrcode"
            tooltipId="save-qr-btn"
            className="public-upload-modal__controls__qr"
            tooltipLabel="Generate QR Code"
            dataCy="share-modal-qr-btn"
            onClick={() => handleDownloadQRCode(link)}>

            Generate QR Code
          </ShareVideoLinkButton>
          <div className="public-upload-modal__controls__buttons">
            <CopyToClipboard text={link} onCopy={handleSave}>
              <Button
                className="public-upload-modal__controls__save"
                onClick={handleSave}
                disabled={isCopied || !link}>

                {isCopied ? 'Copied!' : 'Copy Link'}
              </Button>
            </CopyToClipboard>
            <Button
              className="public-upload-modal__controls__cancel"
              onClick={handleClose}
              type="TERTIARY">

              Cancel
            </Button>
          </div>
        </div>
      </FormModal>
    </div>);

};

export default PublicUploadModal;